import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            探索创作领域
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            五大核心板块，覆盖同人动画创作的全方位需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                      <i className={`${cat.icon} text-background-50 text-sm`}></i>
                    </div>
                    <h3 className="font-heading text-background-50 text-base font-bold">{cat.name}</h3>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}